import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import desktop from "./assets/images/JS RDA.jpeg";
import ros from "./assets/images/rac.png";
import "./assets/css/style.css";
import { useNavigate } from "react-router-dom";
import {
  otpAuthenticateAPI,
  otpGenerateAPI,
  rdaUserAuthenticationAPI,
} from "./APIRequests";
import { OTPModal } from "./Components/OTPModal";
import MD5 from "crypto-js/md5";
import { ErrorModal } from "./Components/ErrorModal";

export const RdaAuthentication = () => {
  const [show, setShow] = useState({ isSuccess: false, isFailed: false });
  const [loading, setloading] = useState(false);
  const [otpVerificationCreds, setotpVerificationCreds] = useState("");
  const [isloading, setisloading] = useState(false);
  const navigate = useNavigate();
  const handleClose = () => {
    setShow({ isSuccess: false, isFailed: false });
    setisloading(false);
  };
  const [errorModal, setErrorModal] = useState({ show: false, message: "" });
  const handleModalClose = () => setErrorModal({ show: false, message: "" });

  const handleShow = (bool, bool2) => {
    setShow({ isSuccess: bool, isFailed: bool2 });
  };

  const [userInfo, setuserInfo] = useState({
    accountNo: "",
    cnic: "",
  });

  const rdaUserAuthevnt = (e) => {
    e.preventDefault();
    setloading(true);
    const rdaInfoHash = JSON.stringify(userInfo);
    var rdaInfoHashHeader = MD5(rdaInfoHash).toString();
    const header = {
      logToken: rdaInfoHashHeader,
    };
    axios
      // .post(rdaUserAuthenticationAPI, userInfo, { headers: header })
      .post(rdaUserAuthenticationAPI, userInfo)
      .then((res) => {
        if (res.status == 200 && res.data.response == "success") {
          setuserInfo({
            ...userInfo,
            fullName: res?.data?.data?.fullName,
          });
          generateOTP(res.data.data);
        } else {
          handleShow(false, true);
          setloading(false);
        }
        // if (responseHash(res.data, res.headers.expires)) {
        //   if (res.status == 200 && res.data.response == "success") {
        //     setuserInfo({
        //       ...userInfo,
        //       fullName: res?.data?.data?.fullName,
        //     });
        //     generateOTP(res.data.data);
        //   } else {
        //     handleShow(false, true);
        //     setloading(false);
        //   }
        // } else {
        //   setErrorModal({ show: true, message: "Han Jani, Infosec?" });
        // }
      })
      .catch((resp) => {
        handleShow(false, true);
        setloading(false);
        handleClose();
        if (resp.request?.status == 429) {
          setErrorModal({ show: true, message: resp?.response?.data?.message });
        } else if (resp.request?.status == 406) {
          setErrorModal({ show: true, message: resp?.response?.data?.message });
        } else if (resp.request?.status == 403) {
          setErrorModal({ show: true, message: resp?.response?.data?.message });
        } else {
          setErrorModal({ show: true, message: "Something went wrong" });
        }
      });
  };

  const verifyOTP = (otp) => {
    setisloading((isState) => !isState);
    const otpVerifyObj = { email: otpVerificationCreds.Email, otp: otp };
    const otpHashString = JSON.stringify(otpVerifyObj);
    var emailHashString = MD5(otpHashString).toString();
    const header = {
      logToken: emailHashString,
    };
    axios
      .post(
        otpAuthenticateAPI,
        otpVerifyObj
        // {
          // headers: {
          //   logToken: emailHashString,
          // },
        // }
      )
      .then((res) => {
        if (responseHash(res.data, res.headers.expires)) {
          if (res.status == 200) {
            const otphash = MD5(JSON.stringify(otp)).toString();
            if (otphash === res.headers["last-modified"]) {
              if (res.data.message === "otp verified") {
                setisloading((isState) => !isState);
                handleClose();
                window.localStorage.setItem("auth", true);
                navigate("/datainput", {
                  state: { auth: { ...userInfo, name: userInfo?.fullName } },
                });
              } else {
                setisloading((isState) => !isState);

                setErrorModal({ show: true, message: res.data.body.message });
              }
            } else {
              setisloading((isState) => !isState);
              setErrorModal({ show: true, message: res.data.body.message });
            }
          } else if (res.status == "406") {
            setisloading((isState) => !isState);
            handleClose();
            setErrorModal({ show: true, message: res.data.message });
          } else if (res.status == "403") {
            setisloading((isState) => !isState);
            handleClose();
            setErrorModal({ show: true, message: res.data.message });
          } else if (res.status == "429") {
            setisloading((isState) => !isState);
            handleClose();
            setErrorModal({ show: true, message: res.data.message });
          } else {
            setisloading((isState) => !isState);
            handleClose();
            setErrorModal({ show: true, message: res.data.message });
          }
        } else {
          setErrorModal({ show: true, message: "Han Jani, Infosec?" });
        }
      })
      .catch((err) => {
        setisloading((isState) => !isState);
        handleClose();
        if (err.request?.status == 1000) {
          setErrorModal({ show: true, message: err?.response?.data?.message });
        } else if (err.request?.status == 406) {
          setErrorModal({ show: true, message: err?.response?.data?.message });
        } else if (err.request?.status == 429) {
          setErrorModal({ show: true, message: err?.response?.data?.message });
        } else if (err.request?.status == 403) {
          setErrorModal({ show: true, message: err?.response?.data?.message });
        } else {
          setErrorModal({ show: true, message: "Something went wrong" });
        }
      });
  };

  const generateOTP = (param) => {
    setotpVerificationCreds({
      FullName: param.fullName,
      Email: param.emailAddress,
      // Email: "mohammad.arsalan@jsbl.com",
    });
    const otpGenHash = {
      email: param?.emailAddress ? param?.emailAddress : "",
      // email: "mohammad.arsalan@jsbl.com",
    };
    const emailHashString = JSON.stringify(otpGenHash);
    var emailHash = MD5(emailHashString).toString();
    const header = {
      logToken: emailHash,
    };
    axios
      .post(
        otpGenerateAPI,
        {
          email: param?.emailAddress ? param?.emailAddress : "",
          // email: "mohammad.arsalan@jsbl.com",
        }
        // { headers: header }
      )
      .then((res) => {
        if (responseHash(res.data, res.headers.expires)) {
          if (res.status == 200) {
            handleShow(true, false);
          }
          setloading(false);
        } else {
          setloading(false);
          setErrorModal({ show: true, message: "Han Jani, Infosec?" });
        }

        // responseHash(res.data, res.headers.expires);
      })
      .catch((err) => {
        setloading(false);
        setisloading((isState) => !isState);
        handleClose();
        if (err.request?.status == 1000) {
          setErrorModal({ show: true, message: err?.response?.data?.message });
        } else if (err.request?.status == 406) {
          setErrorModal({ show: true, message: err?.response?.data?.message });
        } else if (err.request?.status == 429) {
          setErrorModal({ show: true, message: err?.response?.data?.message });
        } else if (err.request?.status == 403) {
          setErrorModal({ show: true, message: err?.response?.data?.message });
        } else {
          setErrorModal({ show: true, message: "Something went wrong" });
        }
      });
  };

  const responseHash = (respData, respHeader) => {
    let data = {};
    if ("data" in respData) {
      data = {
        ...respData,
        data: Object.fromEntries(
          Object.entries(respData.data).filter(([_, v]) => v != null)
        ),
      };
    } else {
      data = {
        ...respData,
        body: Object.fromEntries(
          Object.entries(respData.body).filter(([_, v]) => v != null)
        ),
      };
    }
    const bodyToString = JSON.stringify(data);
    var respBodyHash = MD5(bodyToString).toString();
    return respBodyHash === respHeader ? true : false;
  };


  return (
    <>
      <header>
        <div className="header2">
          <div className="heade2logo">
            {/* <div className="logo">
              <img src={h1} alt="" />
            </div> */}

            <div className="logo">
              <img src={desktop} alt="" />
            </div>

            <div className="logo">
              <img src={ros} alt="" />
            </div>
          </div>
        </div>
      </header>
      <div className="container rdaAuth">
        <Form
          onSubmit={(e) => rdaUserAuthevnt(e)}
          // onSubmit={(e) => generateOTP(e)}
          className="text-center formshado"
        >
          <div className="col-10 m-auto">
            <Form.Group className="mb-3">
              <Form.Label>CNIC Number</Form.Label>
              <Form.Control
                placeholder="CNIC Number"
                type={"number"}
                pattern="[0-9]{5}[0-9]{7}[0-9]{1}"
                required
                value={userInfo.cnic}
                onChange={(e) =>
                  setuserInfo({ ...userInfo, cnic: e.target.value })
                }
              />
            </Form.Group>
          </div>
          <div className="col-10 m-auto">
            <Form.Group className="mb-3">
              <Form.Label>RDA Account Number</Form.Label>
              <Form.Control
                type={"number"}
                placeholder="Account Number"
                required
                value={userInfo.accountNo}
                onChange={(e) =>
                  setuserInfo({ ...userInfo, accountNo: e.target.value })
                }
              />
            </Form.Group>
          </div>

          <Button
            disabled={loading ? true : false}
            className="btn btn-primary next-step loader-btn"
            type="submit"
          >
            Check{" "}
            {loading ? (
              <Spinner
                animation="border"
                role="status"
                variant="light"
              ></Spinner>
            ) : (
              ""
            )}
          </Button>
        </Form>
      </div>

      <OTPModal
        isloading={isloading}
        show={show}
        handleClose={handleClose}
        verifyOTP={verifyOTP}
      />

      <ErrorModal modalProps={errorModal} handleClose={handleModalClose} />
    </>
  );
};
